import React from "react";
import ViewShippingOrderForm from "./ViewShippingOrderForm";

export default function ViewShippingOrder() {
    return (
        <ViewShippingOrderForm type="VIEW" backText="Shipping Orders" backTo={"/shipping-order"} heading={"User Information"} heading2={"Shipping Information"} />
    );
}
